import { z } from 'zod';

export const matchRateSchema = z.object({
  matchRate: z.number(),
});

export type MatchRate = z.infer<typeof matchRateSchema>;
